import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Badge } from './ui/badge';

const QuickViewModal = ({ product, isOpen, onClose, onAddToCart }) => {
  if (!product) return null;

  const discountPercentage = product.discountPercentage || 0;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Vista rápida</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Product Image */}
          <div className="relative aspect-[3/4] bg-muted rounded-lg overflow-hidden">
            <img
              src={product.image}
              alt={product.title}
              className="w-full h-full object-cover"
            />
            {product.isNew && (
              <Badge className="absolute top-4 left-4 bg-primary text-primary-foreground">
                Nuevo
              </Badge>
            )}
            {discountPercentage > 0 && (
              <Badge className="absolute top-4 right-4 bg-accent text-accent-foreground font-bold">
                -{discountPercentage}%
              </Badge>
            )}
          </div>

          {/* Product Details */}
          <div className="flex flex-col">
            <h2 className="text-2xl font-bold mb-4">{product.title}</h2>

            {product.series && (
              <p className="text-sm text-muted-foreground mb-4">
                Serie: <span className="font-medium">{product.series}</span>
              </p>
            )}

            <div className="flex items-center gap-3 mb-6">
              {product.discountPrice ? (
                <>
                  <span className="text-3xl font-bold text-primary">
                    €{product.discountPrice.toFixed(2)}
                  </span>
                  <span className="text-xl text-muted-foreground line-through">
                    €{product.price.toFixed(2)}
                  </span>
                </>
              ) : (
                <span className="text-3xl font-bold text-primary">
                  €{product.price.toFixed(2)}
                </span>
              )}
            </div>

            {product.description && (
              <div className="mb-6">
                <h3 className="font-semibold mb-2">Descripción</h3>
                <p className="text-muted-foreground">{product.description}</p>
              </div>
            )}

            {product.stock && (
              <div className="mb-6">
                <p className="text-sm text-muted-foreground">
                  {product.stock > 10 ? (
                    <span className="text-success">En stock</span>
                  ) : product.stock > 0 ? (
                    <span className="text-accent-foreground">
                      Últimas {product.stock} unidades
                    </span>
                  ) : (
                    <span className="text-destructive">Sin stock</span>
                  )}
                </p>
              </div>
            )}

            <div className="mt-auto space-y-3">
              <Button
                className="w-full gap-2"
                size="lg"
                onClick={() => {
                  onAddToCart(product);
                  onClose();
                }}
              >
                <ShoppingCart className="w-5 h-5" />
                Añadir al carrito
              </Button>
              <Button variant="outline" className="w-full" onClick={onClose}>
                Cerrar
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuickViewModal;